module.exports = __webpack_public_path__ + "static/022-d9bed8b14db024edc80431c12b01a392.jpg";